import axios from 'axios';
import * as endpoint from '../../../endpoint';
import * as actionTypes from '../../../actionTypes';
import {
  consolelog,
  delCancelToken,
  checkCancelToken,
} from '../../../../lib/tools';
import { createCancelToken, handleErrorResponse } from '../../apis';
import { configureAxiosForJSON } from '../../axiosConfig';

/**
 * ユーザー一覧取得APIを呼び出す関数
 *
 * @param {string} apiToken - 認証用APIトークン
 * @param {Object} options - APIリクエストに含めるパラメータ群
 * @param {Function} responseAction - レスポンスが成功した時に実行するreduxアクション
 */
const getOperators = (apiToken, options, responseAction) => dispatch => {
  if (options?.groupIds?.some(groupId => groupId === '')) {
    return Promise.resolve({ message: 'Invalid group ID' });
  }

  consolelog('[API CALL] getOperators()');
  configureAxiosForJSON(apiToken);
  const url = endpoint.API_GET_OPERATORS;
  const { cancelToken, cancelTokenKey } = createCancelToken('getOperators');
  const params = {
    ...options,
    cancelToken,
  };

  return axios
    .post(url, params)
    .then(res => {
      if (checkCancelToken(cancelTokenKey)) {
        dispatch({
          type:
            (responseAction && responseAction) ||
            actionTypes.SUCCESS_API_GET_OPERATORS,
          payload: res.data,
        });
      }
      delCancelToken(cancelTokenKey);
    })

    .catch(thrown => {
      delCancelToken(cancelTokenKey);
      if (!axios.isCancel(thrown)) {
        handleErrorResponse(thrown, dispatch);
      }
    });
};

export default getOperators;
